import { zLocale } from '../../i18n'
import {
  zAnnotationArea,
  zAnnotationHorizontalLine,
  zAnnotationPoint,
  zAnnotationVerticalLine,
  zBackgroundColor,
  zBrush,
  zColor,
  zCrosshairLine,
  zDataset,
  zDimensions,
  zEncoding,
  zLabel,
  zLegend,
  zMeasures,
  zPage,
  zPlayer,
  zPointStyle,
  zRegressionLine,
  zSort,
  zTheme,
  zTooltip,
  zXLinearAxis,
  zYLinearAxis,
} from '../../properties'

import { z } from 'zod'

export const zRaceScatter = z.object({
  chartType: z.literal('raceScatter'),
  dataset: zDataset.nullish(),
  encoding: zEncoding.nullish(),
  dimensions: zDimensions.nullish(),
  measures: zMeasures.nullish(),
  page: zPage.nullish(),

  player: zPlayer.nullish(),
  sort: zSort.nullish(),

  backgroundColor: zBackgroundColor.nullish(),
  size: z.number().or(z.array(z.number())).nullish(),
  sizeRange: z.number().or(z.array(z.number())).nullish(),
  color: zColor.nullish(),
  label: zLabel.nullish(),
  legend: zLegend.nullish(),
  tooltip: zTooltip.nullish(),
  brush: zBrush.nullish(),
  xAxis: zXLinearAxis.nullish(),
  yAxis: zYLinearAxis.nullish(),
  crosshairLine: zCrosshairLine.nullish(),
  theme: zTheme.nullish(),
  pointStyle: z.array(zPointStyle).or(zPointStyle).nullish(),
  annotationPoint: z.array(zAnnotationPoint).or(zAnnotationPoint).nullish(),
  annotationVerticalLine: z.array(zAnnotationVerticalLine).or(zAnnotationVerticalLine).nullish(),
  annotationHorizontalLine: z.array(zAnnotationHorizontalLine).or(zAnnotationHorizontalLine).nullish(),
  annotationArea: z.array(zAnnotationArea).or(zAnnotationArea).nullish(),
  regressionLine: zRegressionLine.nullish(),
  locale: zLocale.nullish(),
})
